// Google Analytics utility functions

/**
 * Track a custom event
 * @param {string} action - The action being performed
 * @param {string} category - The category of the event
 * @param {string} label - Optional label for the event
 * @param {number} value - Optional numeric value for the event
 */
export const trackEvent = (action, category, label = null, value = null) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const eventData = {
      event_category: category,
      event_label: label,
      value: value,
    };

    // Remove null values
    Object.keys(eventData).forEach(key => 
      eventData[key] === null && delete eventData[key]
    );

    window.gtag('event', action, eventData);
    console.log('GA Event tracked:', { action, category, label, value });
  } else {
    console.warn('Google Analytics not loaded - event not tracked:', { action, category, label, value });
  }
};

/**
 * Track page views
 * @param {string} page_title - The title of the page
 * @param {string} page_location - The URL of the page
 */
export const trackPageView = (page_title, page_location = window.location.href) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-442M4N4GWV', {
      page_title: page_title,
      page_location: page_location,
    });
    console.log('GA Page view tracked:', { page_title, page_location });
  } else {
    console.warn('Google Analytics not loaded - page view not tracked:', { page_title, page_location });
  }
};

/**
 * Track language changes
 * @param {string} language - The selected language (pt, en, es)
 */
export const trackLanguageChange = (language) => {
  trackEvent('language_change', 'user_preference', language);
};

/**
 * Track theme changes
 * @param {string} theme - The selected theme (light, dark)
 */
export const trackThemeChange = (theme) => {
  trackEvent('theme_change', 'user_preference', theme);
};

/**
 * Track modal opens
 * @param {string} modalName - The name/type of the modal
 */
export const trackModalOpen = (modalName) => {
  trackEvent('modal_open', 'engagement', modalName);
};

/**
 * Track chat interactions
 * @param {string} action - The chat action (open, close, send_message, etc.)
 */
export const trackChatInteraction = (action) => {
  trackEvent(action, 'chat', null);
};

/**
 * Track link clicks
 * @param {string} linkUrl - The URL being clicked
 * @param {string} linkText - The text of the link
 */
export const trackLinkClick = (linkUrl, linkText) => {
  trackEvent('click', 'outbound_link', linkText, null);
};

/**
 * Track downloads
 * @param {string} fileName - The name of the file being downloaded
 * @param {string} fileType - The type of file (pdf, zip, etc.)
 */
export const trackDownload = (fileName, fileType) => {
  trackEvent('download', 'file', `${fileName} (${fileType})`);
};